module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0f9efe3bd6e80747dfa3aeb9e19997b5.svg";